/**
 * `/control/me` is read by the operator plane too, and the ops bundle may reach `src/app/session/`
 * but not the tenant screens' schemas that `GET_ROUTES` imports, so it is registered here and
 * spread into `GET_ROUTES`.
 */

import { free, type GetRoute } from '../../lib/http/routePath';
import { meSchema } from './schemas';

export const SESSION_GET_ROUTES = {
  me: free('/control/me', meSchema),
} as const satisfies Record<string, GetRoute>;
